import React, { Component } from "react"
//import { func } from "prop-types"
import { connect } from "react-redux"
import { PropTypes } from "prop-types"
import { Link } from "react-router-dom"
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
//import { showModal } from "ducks/modals.js" // eslint-disable-line import/no-extraneous-dependencies
import { Row, Col, Button, Table, FormGroup,FormControl, InputGroup } from "react-bootstrap"
import { URL } from '../../../config'
import userManager from '../../../userManager'
import ContentWrapper from "../../layout/ContentWrapper"
import { getRequest } from '../../../utils/httpRequest'
import { 
  orange,
  red,
  green,
  videoblue 
} from '../../../utils/constants'


const exceptionTypes = {
  All:'all',
  AccountedFor:'accounted',
  Pending:'pending',
  EventName:'eventname'
}

const exceptionsActions = {
  Reconcile:'Reconcile',
  View:'View'
}

class Exception extends Component 
{
  constructor(props)
  {
    super(props)
   
    this.state = {
      exceptions:[],
      searchBy:exceptionTypes.Pending,
      options:[],
      isLoading:true,
      notFound:false
    }
    this.getExceptions  = this.getExceptions.bind(this)
    this.handleExceptionTypeChange = this.handleExceptionTypeChange.bind(this)
    this.handleEventSearch = this.handleEventSearch.bind(this)
  }
  componentDidMount() 
  {
    const { oidc } = this.props

    if (oidc.user == null)
    {
       userManager.signinRedirect()
    }
    else
    {
      this.getExceptions(exceptionTypes.All)
    }
  }
  handleExceptionTypeChange(event) {
    const exceptionType = event.target.value
    let isLoading = false
    if((exceptionType == exceptionTypes.Pending ) || ((exceptionType == exceptionTypes.AccountedFor )))
    {
      isLoading = true
    }
    console.log('Exception handleExceptionTypeChange state searchBy',exceptionType )
    this.setState({ exceptions:[],searchBy:exceptionType,isLoading,notFound:false })
    this.getExceptions(exceptionType)
  }
  handleEventSearch()
  {
    this.setState({ isLoading:true,notFound:false })
    const options =  ['alabama','florida','florencia']
    this.setState({ isLoading:false,options:options })
  }
  getExceptions(exceptionType) 
  {
    const statsendpoint = `/exceptions/${exceptionType}`
    const token = this.props.oidc.user.access_token
    const  eventURL =  `${URL.event}${statsendpoint}` 
    const _this = this
    getRequest(eventURL,'json',token).then(function(response){
      _this.setState({ 
        exceptions:response.data,
        isLoading:false,
        notFound:response.data.length == 0
      })
    })
  }
  render()
   {  
    const { exceptions,searchBy ,options,isLoading,notFound } = this.state

    const showAccountedFor = (searchBy == exceptionTypes.All || searchBy == exceptionTypes.AccountedFor)
    const showPending = (searchBy == exceptionTypes.All || searchBy == exceptionTypes.Pending)
    const searchIcon = isLoading ? 'fa fa-spinner fa-spin':'fa fa-search'
    const _this = this
    return (<ContentWrapper>
      <div className="content-heading">Event Exceptions</div>
      <Row>
        <Col xs={12}>
          <div className="stacked-filter-panel" style={{ width:'100%' }}>
            <FormGroup xs={12}>
              <InputGroup>
                <FormControl  defaultValue={exceptionTypes.All} componentClass="select" 
                  placeholder="All" onChange = { this.handleExceptionTypeChange } 
                  style={{ minWidth:'245px',borderRadious:'0',maxWidth:'60px' }}>
                  <option value={exceptionTypes.All}>All events exceptions</option>
                  {/* <option value={exceptionTypes.Pending}>Pending</option>
                  <option value={exceptionTypes.AccountedFor}>Accounted for</option>
                  <option value={exceptionTypes.EventName}>Event Name</option>  */}
                </FormControl>              
                  { searchBy=='eventname' && 
                    <AsyncTypeahead 
                      labelKey='name'
                      placeholder='Type name...' 
                      type='text'
                      onSearch={this.handleEventSearch}
                      optios={options}
                      isLoading={isLoading}
                      style={{ minWidth:'180px' }}
                    />
                  }
                  { searchBy=='eventname' &&
                    <Button style={{ color:orange }}>
                      <i className={searchIcon} aria-hidden="true" />
                    </Button>
                  }
              </InputGroup>
            </FormGroup>
          </div>
        </Col>
      </Row>
      {
        notFound && (
          <div sm={6}>
            <span style={{ color:videoblue,fontSize:'115%' }}>
              <i className="fa fa-info-circle" aria-hidden="true" />&nbsp;No exceptions found 
            </span>                     
          </div>
        ) 
      }
     { exceptions.length > 0 && (<Row>
      <Col xs={12}>
        <Table striped>
          <thead>
            <tr>
              <th />
              <th style={{ width: "260px" }}>Event Name</th>
              <th>Start Date</th>
              <th>Certification Number</th>
              <th>Number of Exceptions</th>
              {showPending && (<th>Pending</th>)}
              {showAccountedFor && (<th>Accounted For</th>)}
              <th>Status</th>
              <th style={{ width: "60px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {
              exceptions.map((item, key) => (          
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{item.eventName}
                  </td>
                  <td>{item.startDate}</td>
                  <td>{item.certificationNumber}</td>
                  <td>{item.total}</td>
                  {
                    showPending && (<td>{item.pending}</td>)
                  }
                  {
                    showAccountedFor && (<td>{item.fixed}</td>)
                  }
                  <td style={{ color:item.pending > 0 ? red:green,fontWeight:'bold' }}>
                   {
                     item.pending > 0 ? 'Pending':'Accounted for'
                   }
                  </td>
                  <td>
                    <Link to = {
                      { pathname:'/reconciliation',
                        state:{ 
                          eventId: item.eventId ,
                          action:item.pending > 0 ? exceptionsActions.Reconcile:exceptionsActions.View,
                          exceptionType:item.pending > 0 ? _this.state.searchBy:exceptionTypes.All                         
                          // exceptionType:_this.state.searchBy 
                        } 
                      }
                    }>
                    {
                      item.pending > 0 ? exceptionsActions.Reconcile:exceptionsActions.View
                    }
                    </Link>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </Table>
      </Col>
    </Row>)
     }
    </ContentWrapper>)
  }
}

/* Exception.propTypes = {
  handleOpenNewBuilderModal: func,
}
 */
/* const mapDispatchToProps = dispatch => ({
  //handleOpenNewBuilderModal: () => dispatch(showModal("ADD_NEW_BUILDER")),
}) */
Exception.propTypes = {
  oidc: PropTypes.object
}

const mapStateToProps = ({  oidc }) => {
	return {
		oidc: { ...oidc }
	}
}
export default connect(mapStateToProps,null)(Exception)



// WEBPACK FOOTER //
// ./src/components/pages/Exception/index.js